module.exports = __webpack_public_path__ + "TextaNarrow-Regular-webfont.df896a7a6a4244b7a283.svg";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Regular-webfont.svg
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Regular-webfont.svg
// module chunks = styles